export default __webpack_public_path__ + "static/media/sarukhan.4b296ae7.png";